module.exports = __webpack_public_path__ + "img/com.electrolux.egatetogo.a7ad1e4d.webp";